import { render, staticRenderFns } from "./FoodServiceTab.vue?vue&type=template&id=84884f8c&scoped=true"
import script from "./FoodServiceTab.vue?vue&type=script&lang=js"
export * from "./FoodServiceTab.vue?vue&type=script&lang=js"
import style0 from "./FoodServiceTab.vue?vue&type=style&index=0&id=84884f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84884f8c",
  null
  
)

export default component.exports